import React from 'react'
import PropTypes from 'prop-types'
import { IconFAWrapper } from './IconFAWrapper'

export const IconFAXmark = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconFAWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg
        aria-hidden='true'
        focusable='false'
        data-prefix='far'
        data-icon='xmark'
        role='img'
        viewBox="0 0 18 18"
        >
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          d="M14.019 2.11034C14.4195 1.70983 14.4195 1.06219 14.019 0.665942C13.6185 0.269691 12.9708 0.26543 12.5746 0.665942L7.50427 5.73625L2.42971 0.661681C2.02919 0.26117 1.38156 0.26117 0.985308 0.661681C0.589058 1.06219 0.584797 1.70983 0.985308 2.10608L6.05561 7.17638L0.981048 12.2509C0.580536 12.6515 0.580536 13.2991 0.981048 13.6953C1.38156 14.0916 2.02919 14.0959 2.42544 13.6953L7.49575 8.62504L12.5703 13.6996C12.9708 14.1001 13.6185 14.1001 14.0147 13.6996C14.411 13.2991 14.4152 12.6515 14.0147 12.2552L8.94441 7.1849L14.019 2.11034Z"
        />
      </svg>
    </IconFAWrapper>
  )
}

IconFAXmark.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
